import { GetterTree } from 'vuex'
import { RootState } from '@/store'
import { OrdersState } from '@/store/orders'
import { isEqual } from 'lodash'
import { OrderStatus } from '@/api/types'
import moment from 'moment'

const formatSpecificDate = (date: Date) => {
    if (date === null) {
        return null
    }

    return moment(date).format('YYYY-MM-DD')
}

export const getters: GetterTree<OrdersState, RootState> = {
    requestParams(state: OrdersState): any {
        let status: string|string[] = state.statusFilter
        if (status === null) {
            status = [
                OrderStatus.PENDING,
                OrderStatus.SUCCESSFUL,
                OrderStatus.UNSUCCESSFUL,
            ]
        }

        const params = {
            'pagination': true,
            'page': state.page,
            'itemsPerPage': state.itemsPerPage,
            'search': state.search,
            'view': state.direction ? `${state.view}_${state.direction}` : state.view,
            'type': state.typeFilter,
            'status': status,
            'referral.referredBy': state.referredByFilter.map(user => user.id),
            'referral.referredByBranch': state.referredByBranchFilter.map(branch => branch.id),
            'assignedTo': state.assignedToFilter.map(user => user.id),
            'assignedToBranch': state.assignedToBranchFilter.map(branch => branch.id),
            'day': formatSpecificDate(state.dateSpecificFilter),
            'range': state.dateRangeFilter === 'all' ? null : state.dateRangeFilter,
            'age': state.ageFilter,
        }

        if (state.orderField && state.orderDirection) {
            params[`order[${state.orderField}]`] = state.orderDirection
        }

        return params
    },

    activeFilterCount(state: OrdersState): number {
        let count = 0

        Object.keys(state.snapshot).forEach(key => {
            if (!isEqual(state[key], state.snapshot[key])) {
                count++
            }
        })

        return count
    },

    activeFilters(state: OrdersState): string[] {
        const filters = []

        Object.keys(state.snapshot).forEach(key => {
            if (!isEqual(state[key], state.snapshot[key])) {
                filters.push(`${key} = ${state[key]}`)
            }
        })

        return filters
    },

    activeView(state: OrdersState): string {
        return state.view
    },

    activeDirection(state: OrdersState): string {
        return state.direction
    },
}
